var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection-card-small" }, [
    _c("div", { staticClass: "collection-card-small__preview" }, [
      _c("img", {
        staticClass: "collection-card-small__image",
        attrs: { src: _vm.image, alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "collection-card-small__title ta-center" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "collection-card-small__musics" },
      [
        _c(
          "SliderButtons",
          {
            attrs: {
              options: _vm.swiperOption,
              owner: _vm.$parent.$parent,
              "class-button-next": "collection-card-small__button-next",
              "class-button-prev": "collection-card-small__button-prev",
              "class-buttons": "collection-card-small__button"
            }
          },
          _vm._l(_vm.collection, function(ref, idx) {
            var title = ref.title
            return _c("swiper-slide", { key: "track" + idx }, [
              _c(
                "div",
                {
                  class: [
                    "collection-card-small__audio",
                    _vm.isPlayed[idx]
                      ? "collection-card-small__audio-play"
                      : "collection-card-small__audio-pause"
                  ],
                  attrs: {
                    onclick:
                      "\n            const currentCard = this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.__vue__;\n            currentCard.playPause(+this.parentElement.getAttribute('data-swiper-slide-index'));\n          "
                  }
                },
                [_c("p", [_vm._v(_vm._s(title))])]
              )
            ])
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }